import { Dialog } from '@angular/cdk/dialog';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { Injectable, inject } from '@angular/core';
import { DialogContainerComponent } from '@dialog';
import { firstValueFrom } from 'rxjs';
import { ChatDialogComponent } from '../../../../../messaging/features/chat-dialog/src/lib/chat-dialog/chat-dialog.component';
import { SmsDialogComponent, SmsDialogData } from '../../../../../messaging/features/sms-dialog/src/lib/sms-dialog/sms-dialog.component';
import {
  UnlockChatDialogComponent,
  UnlockChatDialogData,
} from '../../../../../messaging/features/unlock-chat-dialog/src/lib/unlock-chat-dialog/unlock-chat-dialog.component';

@Injectable({ providedIn: 'root' })
export class MessagingDialogService {
  private readonly dialog = inject(Dialog);

  openChat(): void {
    this.dialog.open(ChatDialogComponent, {
      width: '600px',
      height: '500px',
      hasBackdrop: false,
      container: DialogContainerComponent,
      scrollStrategy: new NoopScrollStrategy(),
    });
  }

  openSms(patientId: number, patientCell: string): void {
    this.dialog.open(SmsDialogComponent, {
      width: '500px',
      height: '450px',
      hasBackdrop: false,
      container: DialogContainerComponent,
      scrollStrategy: new NoopScrollStrategy(),
      data: { patientId, patientCell } satisfies SmsDialogData,
    });
  }

  async openUnlockChat(data: UnlockChatDialogData): Promise<boolean> {
    const ref = this.dialog.open(UnlockChatDialogComponent, {
      width: '500px',
      container: DialogContainerComponent,
      scrollStrategy: new NoopScrollStrategy(),
      data,
    });
    const result = await firstValueFrom(ref.closed);
    return !!result;
  }
}
